import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import type { User } from '../../../models/user.model';

@Injectable({ providedIn: 'root' })
export class UserService {
    private http = inject(HttpClient);


    getAll() {
        return this.http.get<User[]>(`/users`);
    }
    register(user: User) {
        return this.http.post(`/users/register`, user);
    }
}